import { render, staticRenderFns } from "./CalendarBurgerMenu.vue?vue&type=template&id=5c56f142&scoped=true&"
import script from "./CalendarBurgerMenu.vue?vue&type=script&lang=js&"
export * from "./CalendarBurgerMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c56f142",
  null
  
)

export default component.exports